import isEmpty from 'lodash/isEmpty';
import { EnvItem } from '../../environment-variable';
import { YamlEnvItem } from '../../types';

/**
 * state -> yaml: 转换环境变量数据结构为 YAML
 */
export const envToYaml = (env: EnvItem[]): YamlEnvItem[] => {
  const hasEmptyItem = env?.some((item) => !item.key);
  if (isEmpty(env) || hasEmptyItem) return undefined;

  return env.map((item) => {
    const { type, key, value, resource, resourceKey } = item;

    // 根据环境变量类型处理不同的 YAML 结构
    switch (type) {
      case 'configMapKeyRef':
        return {
          name: key,
          valueFrom: {
            configMapKeyRef: {
              name: resource,
              key: resourceKey,
            },
          },
        };
      case 'secretKeyRef':
        return {
          name: key,
          valueFrom: {
            secretKeyRef: {
              name: resource,
              key: resourceKey,
            },
          },
        };
      // 默认返回自定义类型
      case 'custom':
        return {
          name: key,
          value,
        };
      default:
        return undefined;
    }
  });
};

/**
 * yaml -> state: 转换 YAML 环境变量数据结构为 state
 */
export const yamlToEnv = (yamlEnv?: YamlEnvItem[]): EnvItem[] => {
  if (!yamlEnv || !Array.isArray(yamlEnv)) return undefined;

  return yamlEnv.map((item) => {
    // 使用 'in' 操作符作为类型守卫来检查 valueFrom 属性是否存在
    if ('valueFrom' in item) {
      // 再次使用类型守卫来检查具体的引用类型
      if ('configMapKeyRef' in item.valueFrom && item.valueFrom.configMapKeyRef) {
        return {
          type: 'configMapKeyRef',
          key: item.name,
          resource: item.valueFrom.configMapKeyRef.name,
          resourceKey: item.valueFrom.configMapKeyRef.key,
        };
      }

      if ('secretKeyRef' in item.valueFrom && item.valueFrom.secretKeyRef) {
        return {
          type: 'secretKeyRef',
          key: item.name,
          resource: item.valueFrom.secretKeyRef.name,
          resourceKey: item.valueFrom.secretKeyRef.key,
        };
      }
    }

    // 默认为自定义类型
    return {
      type: 'custom',
      key: item.name,
      value: 'value' in item ? item.value : '',
    };
  });
};
